import {createSelector} from '@reduxjs/toolkit'
import {RootState} from 'app/rootReducer'
import {SSLInspectionStatus} from 'interfaces'
import {PoliciesState} from './policiesSlice'

function getPolicies(state: RootState): PoliciesState {
  return state.policies
}

export const selectPolicies = createSelector(getPolicies, policies => policies)

// Return this SSL Inspection state from unsaved (in-progress) data
export const selectSSLInspectionDisabledInData = createSelector(
  getPolicies,
  ({sslInspectionState}) =>
    sslInspectionState.data === SSLInspectionStatus.DISABLED ||
    (sslInspectionState.data === SSLInspectionStatus.BASE &&
      sslInspectionState.basePolicy === SSLInspectionStatus.DISABLED),
)

// Return this SSL Inspection state from current working data
export const selectSSlInspectionEnabled = createSelector(
  getPolicies,
  ({sslInspectionState}) =>
    sslInspectionState.data === SSLInspectionStatus.ENABLED ||
    (sslInspectionState.data === SSLInspectionStatus.BASE &&
      sslInspectionState.basePolicy === SSLInspectionStatus.ENABLED),
)

export const selectSSLInspectionInherited = createSelector(
  getPolicies,
  ({sslInspectionState}) =>
    sslInspectionState.data === SSLInspectionStatus.BASE,
)

export const selectSSLInspectionData = createSelector(
  getPolicies,
  ({sslInspectionState}) => sslInspectionState.data,
)

export const selectSSLInspectionSnapshot = createSelector(
  getPolicies,
  ({sslInspectionState}) => sslInspectionState.snapshot,
)
